<template>
  <!-- name: '支持我们' -->
  <div class="supportUsWrap">
    <img src="https://img.bbalt.cn/imgh5/other/bg_supportUs.png" alt="" class="bgImgClass" />
    <img
      src="https://img.bbalt.cn/imgh5/other/supportUs_btn.png"
      alt=""
      class="btnImgClass"
      @click="$router.push({ path: '/about', query: { code: 'volunteerTeam' , title: '志愿者团队介绍' } })"
    />
    <div class="btnBox">
      <div class="btnClass" @click="$router.push({ path: '/about', query: { code: 'donate', title: '我要捐款'}})">
          我要捐款
          <img
            src="https://img.bbalt.cn/imgh5/other/icon_triangle_left.svg"
            alt=""
            class="triangleClass"
          />
          <img src="https://img.bbalt.cn/imgh5/other/supportUs_donation.png" alt="" />
      </div>
      <div class="btnClass" @click="$router.push({ path: '/about', query: { code:'monthDonatePlan' , title: '了解月捐人计划' } })">
        <div class="textBox">
          <span>了解</span>
          月捐人计划
        </div>
        <img
          src="https://img.bbalt.cn/imgh5/other/icon_triangle_left.svg"
          alt=""
          class="triangleClass"
          
        />
        <img src="https://img.bbalt.cn/imgh5/other/supportUs_notice.png" alt="" />
      </div>
    </div>
    <div class="becomeBox">
      <div class="becomeClass" @click="$router.push({ path: '/about', query: { code:'beQualityVolunteer' , title: '成为质检志愿者' } })">
        <div class="textBox">
          成为
          <span
            >质检志愿者
            <img
              src="https://img.bbalt.cn/imgh5/other/icon_triangle_left.svg"
              alt=""
              class="triangleClass"
          /></span>

          <div class="bgClass"></div>
        </div>
        <img src="https://img.bbalt.cn/imgh5/other/supportUs_quality.png" alt="" />
      </div>
      <div class="becomeClass" @click="$router.push({ path: '/about', query: { code:'beExpertVolunteer' , title: '成为专家志愿者' } })">
        <div class="textBox">
          成为
          <span
            >专家志愿者
            <img
              src="https://img.bbalt.cn/imgh5/other/icon_triangle_left.svg"
              alt=""
              class="triangleClass"
          /></span>

          <div class="bgClass"></div>
        </div>
        <img src="https://img.bbalt.cn/imgh5/other/supportUs_expert.svg" alt="" />
      </div>
      <div class="becomeClass" @click="$router.push({ path: '/about', query: { code:'beShopManagerVolunteer' , title: '成为店长志愿者' } })">
        <div class="textBox">
          成为
          <span
            >店长志愿者
            <img
              src="https://img.bbalt.cn/imgh5/other/icon_triangle_left.svg"
              alt=""
              class="triangleClass"
          /></span>

          <div class="bgClass"></div>
        </div>
        <img src="https://img.bbalt.cn/imgh5/other/supportUs_shop.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.supportUsWrap {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding-bottom: 37px;
  background: #ffffff
    linear-gradient(
      149deg,
      rgba(103, 159, 210, 0.2) 0%,
      rgba(168, 147, 202, 0.2) 100%
    );
  font-family: PingFangSC, PingFang SC;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  position: relative;
  .bgImgClass {
    width: 100%;
    height: 553px;
  }
  .btnImgClass {
    width: calc(100% - 64px);
    height: 170px;
    position: absolute;
    top: 353px;
    left: 32px;
  }
  .btnBox {
    margin-top: 23px;
    display: flex;
    justify-content: space-between;
    padding: 0px 32px;
    .btnClass,
    a {
      width: 332px;
      height: 192px;
      background: #ffffff;
      border-radius: 16px;
      border: 1px solid #ededed;
      display: flex;
      justify-content: flex-start;
      padding-left: 24px;
      align-items: center;
      font-size: 28px;
      font-weight: 500;
      color: #333333;
      line-height: 36px;

      .textBox {
        display: flex;
        flex-flow: column;
        width: 100%;
        span {
          height: 34px;
          font-size: 26px;
          font-weight: 400;
          color: #333333;
          line-height: 34px;
        }
      }
      img {
        &.triangleClass {
          width: 20px;
          height: 20px;
          margin-right: -12px;
        }
        &:last-child {
          width: 180px;
          height: 180px;
          margin-top: 12px;
        }
      }
      &:last-child {
        .triangleClass {
          margin-right: -40px;
          margin-top: 30px;
        }
      }
    }
    a {
      border: none;
    }
  }
  .becomeBox {
    margin-top: 23px;
    display: flex;
    justify-content: space-between;
    padding: 0px 32px;
    .becomeClass {
      width: 214px;
      height: 201px;
      background: #ffffff;
      border-radius: 16px;
      border: 1px solid #ededed;
      padding-left: 24px;
      text-align: right;
      .textBox {
        width: 100%;
        height: 72px;
        position: relative;
        display: flex;
        flex-flow: column;
        margin-top: 20px;
        margin-bottom: 7px;
        text-align: left;

        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
        span {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            margin-left: 6px;
          }
        }
        .bgClass {
          position: absolute;
          bottom: 0px;
          width: 56px;
          height: 8px;
          background: linear-gradient(
            270deg,
            rgba(255, 231, 138, 0) 0%,
            #feca52 100%
          );
        }

        .triangleClass {
          width: 20px;
          height: 20px;
        }
      }

      img:last-child {
        width: 100px;
        height: 100px;
        margin-right: 12px;
        margin-bottom: 2px;
      }
    }
  }
}
</style>
